import axios from '../../axios/ctiConfig';
import ctiRequest from '../../axios/ctiRequests';
import * as actionTypes from './actionTypes';

export const leadCommentStart = () => {
  return {
    type: actionTypes.LEAD_COMMENT_START,
  };
};

export const leadCommentFail = (error) => {
  return {
    type: actionTypes.LEAD_COMMENT_FAIL,
    error: error,
  };
};

export const leadCommentSuccess = (comments) => {
  return {
    type: actionTypes.LEAD_COMMENT_SUCCESS,
    comments: comments,
  };
};

export const leadComment = (agentId,leadId) => {
  return (dispatch) => {
    dispatch(leadCommentStart());
    ctiRequest['CTI_LEAD_COMMENTS_HISTORY'].agent_id = agentId;
    ctiRequest['CTI_LEAD_COMMENTS_HISTORY'].lead_id = leadId;
    ctiRequest['CTI_LEAD_COMMENTS_HISTORY'].ip = window.clientIP;
    axios
      .post('/', ctiRequest['CTI_LEAD_COMMENTS_HISTORY'])
      .then((result) => {
        if (result.data.response.status === 'SUCCESS') {
          dispatch(leadCommentSuccess(result.data.response.comments));
        } else {
          dispatch(leadCommentFail(result.data.response.reason));
          //console.log(result.data.response.reason);
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch(leadCommentFail(err));
      });
  };
};